var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.item)
    ? _c(
        "div",
        { staticClass: "categ_info" },
        [
          _c("info_field", {
            attrs: {
              f_uniq: "ct",
              f_type: "displayName",
              f_title: _vm.__t("NAME"),
              is_disabled: _vm.is_disabled,
              f_val: _vm.cur_item.displayName,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "short_code",
              f_type: "short_code",
              f_title: _vm.__t("SHORT_CODE"),
              is_disabled: _vm.is_disabled,
              f_val: _vm.cur_item.short_code,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid",
              f_title: _vm.__t("UNIQ_GO_CODE"),
              f_val: _vm.cur_item.id.toString(),
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cuid",
              f_title: _vm.__t("UNIQ_PROV_CODE"),
              f_val: _vm.cur_item.uniq_id,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group mt-2" },
            [
              _c("div", { staticClass: "panel-tag" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t("EMPLOY_NAME_DATA")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("info_field", {
                attrs: {
                  f_uniq: "firstName",
                  f_type: "firstName",
                  f_title: _vm.__t("FIRST_NAME"),
                  is_disabled: _vm.is_disabled,
                  f_val: _vm.cur_item.firstName,
                },
                on: { update_categ: _vm.change_atr },
              }),
              _vm._v(" "),
              _c("info_field", {
                attrs: {
                  f_uniq: "middleName",
                  f_type: "middleName",
                  f_title: _vm.__t("MIDDLE_NAME"),
                  is_disabled: _vm.is_disabled,
                  f_val: _vm.cur_item.middleName,
                },
                on: { update_categ: _vm.change_atr },
              }),
              _vm._v(" "),
              _c("info_field", {
                attrs: {
                  f_uniq: "lastName",
                  f_type: "lastName",
                  f_title: _vm.__t("LAST_NAME"),
                  is_disabled: _vm.is_disabled,
                  f_val: _vm.cur_item.lastName,
                },
                on: { update_categ: _vm.change_atr },
              }),
              _vm._v(" "),
              _c("info_field", {
                attrs: {
                  f_uniq: "phone",
                  f_type: "phone",
                  f_title: _vm.__t("PHONE"),
                  is_disabled: _vm.is_disabled,
                  f_val: _vm.cur_item.phone,
                },
                on: { update_categ: _vm.change_atr },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "organization" } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t("ORGANIZATION")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.organizations.length > 0
              ? _c(
                  "div",
                  {},
                  [
                    _c(
                      "v-select",
                      {
                        staticClass: "imc_reasons",
                        attrs: {
                          label: "title",
                          reduce: function (item) {
                            return item.id
                          },
                          options: this.organizations,
                          filterable: false,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "option",
                              fn: function (option) {
                                return [
                                  _c("div", { staticClass: "d-center" }, [
                                    _c("div", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(option.title) +
                                          "\n                            "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "small badge border border-info text-info mr-1",
                                        },
                                        [_vm._v(" " + _vm._s(option.provider))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("small", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(option.uniq_id) +
                                            "\n                            "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1273522967
                        ),
                        model: {
                          value: _vm.cur_item.org_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.cur_item, "org_id", $$v)
                          },
                          expression: "cur_item.org_id",
                        },
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.__t("CHOICE_ORG")) +
                              "\n                "
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }